import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'

export const QuotationIcon = ReceiptLongIcon
export default QuotationIcon
